import React from 'react';
import { render } from 'react-dom';
import { HeartbeatNew } from '@atlassian/heartbeat';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import { provideHealthcheck } from '@atlassian/jira-common-healthcheck/src/utils/healthcheck-utils/index.tsx';
import { JiraContextContainer } from '@atlassian/jira-context-container/src/JiraContextContainer.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

provideHealthcheck();

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const container = document.createElement('div');
container.id = 'heartbeat';

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild(container);

render(
	<StrictMode>
		<JiraContextContainer>
			<TenantContextSubscriber>
				{({ tenantContext: { isAnonymous } }) =>
					!isAnonymous && (
						<AppBase id="heartbeat">
							<HeartbeatNew />
						</AppBase>
					)
				}
			</TenantContextSubscriber>
		</JiraContextContainer>
	</StrictMode>,
	container,
);
